export const STATUS = Object.freeze({
  STATUS_SUCCESS: 'success',
  STATUS_FAILED: 'failed',
  STATUS_ONGOING: 'ongoing',
  STATUS_EXISTING: 'existing'
});
